import styled from 'styled-components';

import { useGetMicrostoreColumnsOfOrganizationQuery } from 'data/__generated__';

import { SectionColumn } from 'components/DetailsView/Section';
import { Loader, LoaderModeType } from 'components/Loader';

import { ConsumptionConfigurationDetails } from './ConsumptionConfigurationDetails';
import { RmeConfigurationDetails } from './RmeConfigurationDetails';

/**
 * Le contenu de la section « Configuration facturation », monté seulement si `MicrostoreColumnsRead` est
 * détenu : les colonnes ne servent qu'aux sélecteurs d'ici. Les valeurs du formulaire viennent du `reset()`
 * de la page, les champs peuvent donc s'enregistrer une fois les colonnes arrivées.
 */
export const InvoiceConfigurationContent = ({
    organizationId,
    B2BPriceRangeId,
}: {
    organizationId: string;
    B2BPriceRangeId?: string | null;
}) => {
    const { data, loading, error } = useGetMicrostoreColumnsOfOrganizationQuery({ variables: { organizationId } });

    if (loading && !data) {
        return <Loader mode={LoaderModeType.Spin} />;
    }

    if (error || !data) {
        return <ErrorMessage>Erreur lors de la récupération des colonnes de l'organisation</ErrorMessage>;
    }

    const microstoreColumns = data.microstoreColumnsOfOrganization;

    return (
        <ResponsiveColumnContainer>
            <FirstColumn>
                <ConsumptionConfigurationDetails
                    microstoreColumns={microstoreColumns}
                    B2BPriceRangeId={B2BPriceRangeId}
                />
            </FirstColumn>
            <SecondColumn>
                <RmeConfigurationDetails microstoreColumns={microstoreColumns} />
            </SecondColumn>
        </ResponsiveColumnContainer>
    );
};

const ResponsiveColumnContainer = styled.div`
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
`;

const FirstColumn = styled(SectionColumn)`
    width: calc(57% - 10px);

    @media (max-width: 2100px) {
        width: 100%;
    }
`;

const SecondColumn = styled(SectionColumn)`
    width: calc(43% - 10px);

    @media (max-width: 2100px) {
        width: 100%;
    }
`;

const ErrorMessage = styled.div`
    color: ${({ theme }) => theme.errorColor};
    padding: 10px;
`;
